/**
 * 翻译核心逻辑
 * 提供与翻译流程相关的核心功能和实用函数
 *
 * 核心功能：
 * 1. 验证翻译请求参数有效性
 * 2. 格式化和标准化翻译结果
 * 3. 提供文本字符数计算工具
 * 4. 支持翻译成本估算
 * 5. 确保翻译输出一致性和可靠性
 */
/**
 * 验证翻译请求参数
 * @param request 翻译请求
 * @returns 验证结果，包含是否有效和错误信息
 */
export function validateTranslationRequest(request) {
    if (!request.text || request.text.trim().length === 0) {
        return { isValid: false, error: 'Translation text cannot be empty' };
    }
    // 限制文本长度，避免API滥用
    if (request.text.trim().length > 5000) {
        return { isValid: false, error: 'Translation text cannot exceed 5000 characters' };
    }
    return { isValid: true };
}
/**
 * 格式化翻译结果，确保结果格式一致性
 * @param result 原始翻译结果
 * @returns 格式化后的翻译响应
 */
export function formatTranslationResult(result) {
    // 确保analysis字段存在，以避免TypeScript错误
    const analysis = result.analysis || {};
    // 检查是否有任何分析数据
    const hasAnalysisData = !!(analysis.grammar ||
        analysis.context ||
        analysis.style ||
        analysis.directTranslation ||
        analysis.contextualMeaning);
    if (!hasAnalysisData) {
        // 日志记录 - 帮助调试
        console.warn('翻译结果中没有分析数据:', result);
    }
    // 确保所有必要字段都存在
    const formatted = {
        originalText: result.originalText || '',
        translatedText: result.translatedText || '',
        provider: result.provider, // 假设这个字段已存在
    };
    // 仅当有分析数据时才添加analysis字段
    if (hasAnalysisData) {
        formatted.analysis = {
            // 保留所有类型的分析字段
            grammar: analysis.grammar,
            context: analysis.context,
            style: analysis.style,
            // DeepSeek特定字段
            directTranslation: analysis.directTranslation,
            contextualMeaning: analysis.contextualMeaning,
        };
    }
    // 如果有错误信息，保留它
    if (result.error) {
        formatted.error = result.error;
    }
    return formatted;
}
/**
 * 计算文本的大致字符数，用于API计费估算
 * @param text 输入文本
 * @returns 大致字符数
 */
export function estimateTextCharacters(text) {
    if (!text)
        return 0;
    return text.trim().length;
}
/**
 * 计算翻译可能的费用（仅估算）
 * @param text 输入文本
 * @param pricePerThousandChars 每千字符价格（货币单位）
 * @returns 估算费用
 */
export function estimateTranslationCost(text, pricePerThousandChars) {
    const chars = estimateTextCharacters(text);
    return (chars / 1000) * pricePerThousandChars;
}
//# sourceMappingURL=translation.js.map